import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import classNames from "classnames";
import DomPurify from "isomorphic-dompurify";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import ArrowRight from "../../icons/arrow-right.svg";
import { replaceStringPlaceholder } from "../../utils/replaceStringPlaceholder/replaceStringPlaceholder";
import { Accordion } from "../Accordion";
import { AccordionItem } from "../AccordionItem";
import { Icon } from "../Icon";
import styles from "./Faq.module.scss";
const { sanitize } = DomPurify;
export const Faq = ({ title, details, detailsLink, additionalHelp, additionalHelpEmail, faqList = [], }) => {
    const additionalString = useMemo(() => replaceStringPlaceholder(additionalHelp, [
        {
            placeholder: "helpEmail",
            value: additionalHelpEmail,
            tag: "a",
            additionalProps: `href="mailto:${additionalHelpEmail}"`,
        },
    ]), [additionalHelp, additionalHelpEmail]);
    const dispatchGTMEvent = (title) => {
        dispatchTrackingEvent(TrackingEvents.TrackingFaqLink, { faq_name: title });
    };
    if (!faqList.length) {
        return null;
    }
    return (_jsx("div", { className: styles.faqBackground, children: _jsxs("div", { className: styles.faqWrapper, children: [_jsxs("div", { className: styles.leftBlock, children: [_jsx("h1", { className: styles.title, "data-testid": "faq-title", children: title }), _jsx("p", { className: styles.details, children: _jsxs("a", { href: detailsLink, "data-testid": "faq-more-link", onClick: () => dispatchGTMEvent(title), children: [details, _jsx(Icon, { dataTestId: "faq-arrow-icon", className: styles.arrowIcon, component: ArrowRight, width: "2.8em", height: "2.8em" })] }) })] }), _jsxs("div", { className: classNames(styles.rightBlock, "light-theme"), children: [_jsx(Accordion, { dispatchGTMEvent: dispatchGTMEvent, children: faqList.map(({ faqTitle, faqDetails }) => (_jsx(AccordionItem, { id: faqTitle, title: faqTitle, children: _jsx("span", { className: styles.faqItemContent, children: faqDetails }) }, faqTitle))) }), additionalString && (_jsx("p", { className: styles.help, dangerouslySetInnerHTML: { __html: sanitize(additionalString) }, "data-testid": "faq-help" }))] })] }) }));
};
//# sourceMappingURL=Faq.js.map